module.exports = __webpack_public_path__ + "img/90sgraphicsedited.a48e86c1.png";